import { Link } from 'react-router-dom';
import {
  ArrowLeft,
  Mail,
  Phone,
  MapPin,
  FileText,
  Building2,
  Clock,
  ArrowUpRight,
} from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const SUPPORT_EMAIL = 'resstrosaas@mail.ru';
const GENERAL_EMAIL = 'admin@resstro.ru';

// Контактный телефон для каналов связи (карточки, кнопка WhatsApp).
const PHONE_HUMAN = '+7 989 473-43-22';
const PHONE_TEL = '+79894734322';
const WHATSAPP_URL = 'https://wa.me/79894734322';

// Реквизиты исполнителя (152-ФЗ), официальные данные ИП для договоров
// и закрывающих документов. Телефон и юр. адрес тут отличаются от
// контактных каналов выше: это «бумажные» реквизиты.
const REQUISITE_PHONE_HUMAN = '+7 964 678-88-89';
const REQUISITE_PHONE_TEL = '+79646788889';

const REQUISITES = [
  { label: 'Полное наименование', value: 'Индивидуальный предприниматель Раджабов Рустам Эфлетдинович' },
  { label: 'Сокращённое', value: 'ИП Раджабов Р. Э.' },
  { label: 'ИНН', value: '051707862851' },
  { label: 'Email для документов', value: SUPPORT_EMAIL, href: `mailto:${SUPPORT_EMAIL}` },
  { label: 'Email (общий)', value: GENERAL_EMAIL, href: `mailto:${GENERAL_EMAIL}` },
  { label: 'Телефон / WhatsApp', value: REQUISITE_PHONE_HUMAN, href: `tel:${REQUISITE_PHONE_TEL}` },
  { label: 'Юр. адрес', value: 'Россия, Республика Дагестан, Кизлярский район, село Малая Арешевка, улица Кирова, 21' },
];

export default function Contacts() {
  return (
    <div className="min-h-screen bg-paper">
      <Header />

      <section className="section">
        <div className="container-site">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[13px] font-medium text-ink/60 transition hover:text-ink"
          >
            <ArrowLeft size={14} strokeWidth={1.75} />
            На главную
          </Link>

          <div className="mt-10 grid gap-12 md:grid-cols-12">
            {/* Лево, заголовок и каналы */}
            <div className="md:col-span-7">
              <span className="eyebrow">Контакты</span>
              <h1 className="h2 mt-4 max-w-xl">Связь, договоры и&nbsp;документы</h1>
              <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-ink/70">
                Это юридическая страница: реквизиты для договоров, счётов и&nbsp;писем
                в&nbsp;Роскомнадзор. По&nbsp;вопросам поддержки и&nbsp;настройки
                напишите в&nbsp;<Link to="/support" className="link">раздел поддержки</Link>,
                там быстрее.
              </p>

              {/* Каналы */}
              <div className="mt-10 grid gap-4">
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  className="group flex items-start gap-5 border border-line bg-white p-6 transition hover:border-ink"
                >
                  <span
                    className="grid h-11 w-11 shrink-0 place-items-center border border-line bg-paper text-ink/70"
                    aria-hidden="true"
                  >
                    <Mail size={18} strokeWidth={1.75} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/50">
                      Email
                    </div>
                    <div className="mt-2 text-[18px] font-medium text-ink">{SUPPORT_EMAIL}</div>
                    <div className="mt-1 text-[13px] text-ink/60">
                      Договоры, счета, бухгалтерские запросы, обращения по&nbsp;152-ФЗ.
                    </div>
                  </div>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1.75}
                    className="mt-1 shrink-0 text-ink/40 transition group-hover:text-ink"
                  />
                </a>

                <a
                  href={`mailto:${GENERAL_EMAIL}`}
                  className="group flex items-start gap-5 border border-line bg-white p-6 transition hover:border-ink"
                >
                  <span
                    className="grid h-11 w-11 shrink-0 place-items-center border border-line bg-paper text-ink/70"
                    aria-hidden="true"
                  >
                    <Mail size={18} strokeWidth={1.75} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/50">
                      Email (общий)
                    </div>
                    <div className="mt-2 text-[18px] font-medium text-ink">{GENERAL_EMAIL}</div>
                    <div className="mt-1 text-[13px] text-ink/60">
                      Общие вопросы, поддержка и&nbsp;подключение.
                    </div>
                  </div>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1.75}
                    className="mt-1 shrink-0 text-ink/40 transition group-hover:text-ink"
                  />
                </a>

                <a
                  href={`tel:${PHONE_TEL}`}
                  className="group flex items-start gap-5 border border-line bg-white p-6 transition hover:border-ink"
                >
                  <span
                    className="grid h-11 w-11 shrink-0 place-items-center border border-line bg-paper text-ink/70"
                    aria-hidden="true"
                  >
                    <Phone size={18} strokeWidth={1.75} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/50">
                      Телефон / WhatsApp
                    </div>
                    <div className="mt-2 text-[18px] font-medium text-ink">{PHONE_HUMAN}</div>
                    <div className="mt-1 text-[13px] text-ink/60">
                      Звонки и&nbsp;сообщения в&nbsp;WhatsApp по&nbsp;всем вопросам.
                    </div>
                  </div>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1.75}
                    className="mt-1 shrink-0 text-ink/40 transition group-hover:text-ink"
                  />
                </a>
              </div>

              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-dark"
                >
                  Написать в&nbsp;WhatsApp
                </a>
                <Link to="/support" className="btn-outline">
                  Поддержка и&nbsp;FAQ
                </Link>
              </div>
            </div>

            {/* Право, реквизиты */}
            <div className="md:col-span-5">
              <div className="border border-line bg-white">
                <div className="flex items-center justify-between border-b border-line bg-paper/60 px-6 py-4">
                  <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-ink/55">
                    <Building2 size={13} strokeWidth={1.75} />
                    Реквизиты исполнителя
                  </div>
                  <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/40">
                    152-ФЗ
                  </div>
                </div>
                <dl className="divide-y divide-line">
                  {REQUISITES.map((r) => (
                    <div
                      key={r.label}
                      className="grid grid-cols-[140px_1fr] items-baseline gap-4 px-6 py-3"
                    >
                      <dt className="text-[11.5px] uppercase tracking-[0.08em] text-ink/45">
                        {r.label}
                      </dt>
                      <dd className="text-[13px] text-ink">
                        {r.href ? (
                          <a
                            href={r.href}
                            className="text-ink hover:text-orange transition-colors"
                          >
                            {r.value}
                          </a>
                        ) : (
                          <span className={r.label === 'ИНН' ? 'tabular-nums' : ''}>
                            {r.value}
                          </span>
                        )}
                      </dd>
                    </div>
                  ))}
                </dl>
                <div className="border-t border-line bg-paper/40 px-6 py-3 text-[11px] leading-relaxed text-ink/55">
                  Закрывающие документы, счёт и&nbsp;договор оферты выписываем по&nbsp;
                  запросу на&nbsp;{SUPPORT_EMAIL}.
                </div>
              </div>

              <div className="mt-6 border border-line bg-white">
                <div className="flex items-center justify-between border-b border-line bg-paper/60 px-6 py-4">
                  <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-ink/55">
                    <Clock size={13} strokeWidth={1.75} />
                    Время ответа
                  </div>
                  <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/40">
                    МСК · UTC+3
                  </div>
                </div>
                <ul className="divide-y divide-line">
                  <li className="flex items-center justify-between gap-4 px-6 py-4">
                    <span className="text-[13px] font-medium text-ink">WhatsApp</span>
                    <span className="text-[13px] text-ink/65">~15 минут, 09–22</span>
                  </li>
                  <li className="flex items-center justify-between gap-4 px-6 py-4">
                    <span className="text-[13px] font-medium text-ink">Email</span>
                    <span className="text-[13px] text-ink/65">в&nbsp;течение рабочего дня</span>
                  </li>
                  <li className="flex items-center justify-between gap-4 px-6 py-4">
                    <span className="text-[13px] font-medium text-ink">Запросы по&nbsp;152-ФЗ</span>
                    <span className="text-[13px] text-ink/65">до&nbsp;10&nbsp;рабочих дней</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 border border-line bg-white p-5">
                <div className="flex items-start gap-3 text-[12.5px] leading-relaxed text-ink/65">
                  <FileText size={14} strokeWidth={1.75} className="mt-0.5 shrink-0 text-ink/50" />
                  <div>
                    Документы:&nbsp;
                    <Link to="/legal/offer" className="link">
                      Оферта
                    </Link>
                    ,&nbsp;
                    <Link to="/legal/privacy" className="link">
                      Политика конфиденциальности
                    </Link>
                    ,&nbsp;
                    <Link to="/legal/consent" className="link">
                      Согласие на&nbsp;обработку
                    </Link>
                    ,&nbsp;
                    <Link to="/legal/cookies" className="link">
                      Cookies
                    </Link>
                    ,&nbsp;
                    <Link to="/legal/return" className="link">
                      Возвраты
                    </Link>
                    ,&nbsp;
                    <Link to="/legal/security" className="link">
                      Безопасность
                    </Link>
                    .
                  </div>
                </div>
              </div>

              <div className="mt-6 flex items-start gap-3 text-[11.5px] leading-relaxed text-ink/55">
                <MapPin size={13} strokeWidth={1.75} className="mt-0.5 shrink-0 text-ink/40" />
                <span>
                  Серверы и&nbsp;база данных размещены в&nbsp;дата-центрах на&nbsp;территории
                  Российской Федерации. Трансграничная передача персональных данных
                  не&nbsp;осуществляется.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
